<div class="text-area-row">
    <mat-form-field appearance="outline" class="width-max">
        <mat-label>{{ editLabel | translate }}</mat-label>
        <textarea matInput readonly rows="3" autocomplete="off" [disabled]="isDisabled"
            (click)="selectGroupGoal()"
        >{{ groupGoalDisplayText }}</textarea>
    </mat-form-field>

    <div class="button-group">
        <button mat-flat-button color="accent" class="lg-button2" (click)="selectGroupGoal()" [disabled]="isDisabled">{{ 'GROUP_GOAL_FIELD.ASSIGN_TEAM_GOAL' | translate }}</button>
    </div>
</div>
